import Select from 'react-select';
import styled from 'styled-components/macro';

import { Flex } from 'components/styled/Flex';

export const InfoBoxContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.one};
`;

export const ReservationStatus = styled.h6`
  margin-bottom: ${({ theme }) => theme.spacing.zero_2};

  color: ${({ theme }) => theme.colors.black_80};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
`;

export const ReservedBy = styled.h4`
  margin-bottom: ${({ theme }) => theme.spacing.one_2};

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
`;

export const ReservationOverviewItem = styled.div`
  display: flex;
  margin: ${({ theme }) => theme.spacing.one} 0;
`;

export const InfoLabel = styled.h5`
  width: fit-content;
  margin-left: ${({ theme }) => theme.spacing.zero_3};

  color: ${({ theme }) => theme.colors.black_100};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  word-break: break-word;
`;

export const PriceBoxContainer = styled.div`
  display: flex;
  border-top: ${({ theme }) => `1px solid ${theme.colors.black_10}`};
  border-radius: 0 0 8px 8px;

  background-color: ${({ theme }) => theme.colors.black_5};
`;

export const PriceBoxItem = styled.div`
  width: 33.33%;
  height: 3.875rem;
  padding: ${({ theme }) => theme.spacing.zero_2} ${({ theme }) => theme.spacing.zero_1};
  :nth-child(2) {
    border-right: ${({ theme }) => `1px solid ${theme.colors.black_10}`};
    border-left: ${({ theme }) => `1px solid ${theme.colors.black_10}`};
  }
`;

export const PriceBoxNameLabel = styled.h5`
  height: 1.5rem;

  color: ${({ theme }) => theme.colors.black_60};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  line-height: 1.71;
  text-align: center;
`;

export const PriceBoxValueLabel = styled.h5<{ total?: boolean }>`
  height: 1.5rem;

  color: ${({ theme, total }) => (total ? theme.colors.black_100 : theme.colors.black_80)};
  font-weight: ${({ theme, total }) =>
    total ? theme.fontWeight.medium : theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ theme, total }) =>
    total ? theme.fontFamily.medium : theme.fontFamily.regular};
  line-height: 1.71;
  text-align: center;
`;

export const Dropdown = styled(Select)`
  width: 50%;
  margin-right: ${({ theme }) => theme.spacing.one};

  .true__control {
    border: 1px solid;
    border-color: ${({ theme }) => theme.colors.black_10};
    border-radius: ${({ theme }) => theme.spacing.zero_1};

    background-color: ${({ theme }) => theme.colors.black_10};

    &--is-focused {
      border-color: ${({ theme }) => theme.colors.black};
    }

    :hover {
      border-color: ${({ theme }) => theme.colors.black_10};
    }
  }
  .true__control--menu-is-open {
    border: 1px solid;
    border-color: ${({ theme }) => theme.colors.black_20} !important;

    background-color: ${({ theme }) => theme.colors.black_20};

    box-shadow: none;
  }

  .true__indicator-separator {
    display: none;
  }

  .true__indicator {
    color: ${({ theme }) => theme.colors.black_80};
  }

  .true__single-value {
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-family: ${({ theme }) => theme.fontFamily.semiBold};
  }
  .true__menu {
    width: 11rem;

    color: ${({ theme }) => theme.colors.black_100};
    font-size: ${({ theme }) => theme.fontSize.xxs};
    letter-spacing: ${({ theme }) => theme.letterSpacing.md};

    :after {
      position: absolute;
      top: -6px;
      right: 90px;

      width: 0;
      height: 0;
      border-right: 5px solid transparent;
      border-bottom: 6px solid ${({ theme }) => theme.colors.white};
      border-left: 5px solid transparent;

      content: '';
    }

    :before {
      position: absolute;
      top: -7px;
      right: 89px;

      width: 0;
      height: 0;
      border-right: 6px solid transparent;
      border-bottom: 6px solid ${({ theme }) => theme.colors.black_10};
      border-left: 6px solid transparent;

      content: '';
    }
  }
`;

export const InlineIconWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.zero_1};
`;

export const IconWrapper = styled.div`
  line-height: 1.71rem;
`;
export const ReservationInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.zero_2};
`;
export const CreatedOn = styled.h5`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.colors.black_80};
`;

export const ReservationStatusWrapper = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.zero_2};
`;

export const Label = styled.h5<{ gray?: boolean }>`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xs};
  line-height: ${({ theme }) => theme.lineHeight.one_2};

  color: ${({ theme, gray }) => (gray ? theme.colors.black_80 : theme.colors.black_100)};
`;

export const PartnerLogo = styled.img`
  max-width: 9rem;
  height: auto;
  max-height: 4rem;
`;

export const AccordionLabel = styled.p<{ margin?: string }>`
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  color: ${({ theme }) => theme.colors.black_100};

  ${({ margin }) => margin && ` margin: ${margin}; `}
`;

export const ReservationOverviewContainer = styled.div<{ margin?: string }>`
  border: 1px solid ${({ theme }) => theme.colors.black_20};
  border-radius: ${({ theme }) => theme.spacing.zero_2};
  background-color: ${({ theme }) => theme.colors.white};

  ${({ margin }) => margin && ` margin: ${margin}; `}
`;

export const CopyIconWrapper = styled.span`
  position: relative;
  cursor: pointer;
`;
